import { useEffect, useMemo, useCallback } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { UsuarioService } from '../../service/UsuarioService';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';
import { RolUsuarioModel } from '../../models/administracion/RolUsuarioModel';

export const RolUsuario = ({ id, toast, permss }) => {
    const usuarioService = useMemo(() => new UsuarioService(), []);
    const tablaEstado = useLazyParams({ modelo: RolUsuarioModel });

    useEffect(() => {
        if (id) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { id: id, ...tablaEstado.lazyParams };
        tablaEstado.setLoading(true);
        usuarioService.getRolUsuario({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al cargar los roles', life: 3000 });
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    };

    const handleAsignar = useCallback((checked, rowData) => {
        const rolId = rowData.id;
        // Activar spinner únicamente en la fila afectada
        tablaEstado.setData(prev => prev.map(row =>
            row.id === rolId ? { ...row, loading_asignar: true } : row
        ));
        usuarioService.putPermission({ id: rolId, usu: id, agregar: checked }).then(res => {
            // Actualizar estado localmente
            tablaEstado.setData(prev => prev.map(row =>
                row.id === rolId ? { ...row, loading_asignar: false, asignado: checked, fecha: checked ? new Date().toISOString() : null } : row
            ));
            toast.current.show({ severity: 'success', summary: 'Exitoso', detail: res?.message || 'Rol actualizado correctamente', life: 3000 });
        }).catch(error => {
            // Revertir spinner en caso de error
            tablaEstado.setData(prev => prev.map(row =>
                row.id === rolId ? { ...row, loading_asignar: false } : row
            ));
            toast.current.show({ severity: 'error', summary: 'Error', detail: error?.message || 'No se pudo actualizar el rol', life: 3000 });
        });
    }, [id, usuarioService, tablaEstado, toast]);

    // Templates personalizados para las celdas
    const cuerpoTemplates = useMemo(() => ({
        columnaAsignar: (rowData) => {
            const isProcessing = rowData.loading_asignar === true;
            const tienePermiso = Boolean(permss?.crear || permss?.actualizar);

            return (
                <div className="flex justify-content-center align-items-center" style={{ height: '2rem' }}>
                    {isProcessing ? (
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.4rem', color: 'var(--primary-color)' }}></i>
                    ) : (
                        <Checkbox checked={rowData.asignado === true} disabled={!tienePermiso} onChange={(e) => handleAsignar(e.checked, rowData)} />
                    )}
                </div>
            );
        }
    }), [handleAsignar, permss]);

    return (
        <TablaDinamica modelo={RolUsuarioModel} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} cuerpoTemplates={cuerpoTemplates} dataKey="id" size="small" />
    );
};